import request from '@/utils/request'

/**
 * 发送登录验证码
 * @param {string} phone - 手机号（11位）
 */
export function sendCode(phone) {
  return request.post('/supplier/auth/sendCode', { phone })
}

/**
 * 供应商登录（手机号 + 验证码）
 * @param {string} phone
 * @param {string} verify_code
 */
export function login(phone, verify_code) {
  return request.post('/supplier/auth/login', { phone, verify_code })
}

/**
 * 兼容旧调用：phoneLogin -> login
 */
export function phoneLogin(phone, verify_code) {
  return login(phone, verify_code)
}

/**
 * 获取当前登录供应商信息
 */
export function getProfile() {
  return request.get('/supplier/auth/profile')
}

/**
 * 退出登录
 */
export function logout() {
  return request.post('/supplier/auth/logout')
}
